'use client';

import { useParams } from 'next/navigation';
import { SpNavigationIsland } from '@portals/ui-kit-dpa';
import { usePathname, useRouter } from '@/i18n/navigation';
import { getCategoriesRoute, TMultiPageRouteParams } from '@/_constants/routes';
import { CategoryButton } from '@/components/server-category-tree/_components/server-category-tree-display/_components/category-button';

type TProps = {
  buttonText: string;
};

export const ClientGoToHomeButton = ({ buttonText }: TProps) => {
  const router = useRouter();
  const params = useParams<TMultiPageRouteParams>();
  const pathname = usePathname();

  const categoryPath = getCategoriesRoute({ country: params.country });
  const isHomeRoute = pathname === categoryPath;

  const handleClick = () => {
    router.push(categoryPath);
  };

  return (
    <SpNavigationIsland onItemClick={handleClick} activeId="">
      <CategoryButton
        id="home-category-button"
        isExpanded={isHomeRoute}
        text={buttonText}
      />
    </SpNavigationIsland>
  );
};
